<template>
  <cookie-law>
    <div
      slot-scope="props"
      class="flex flex-col space-y-5 lg:space-y-0 lg:flex-row lg:space-x-5 items-center"
    >
      <p class="text-base">
        En poursuivant votre navigation, sans changer les paramètres de votre navigateur, vous acceptez l'utilisation de cookies pour garantir une bonne expérience sur notre site.
      </p>

      <a 
        target="_blank"
        class="text-base" 
        href="https://www.neopass.fr/politique-de-confidentialite%e2%80%8b/"
      >
        Politique de confidentialité
      </a>
            
      <div class="flex space-x-5 justify-center">
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          libelle="Ignorer"
          :uppercase="true"
          @clickAction="props.close"
        />
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-indigo-600"
          bg-color-square="bg-indigo-600"
          icon-color="text-white"
          libelle="Accepter"
          :uppercase="true"
          @clickAction="props.accept"
        />
      </div>
    </div>
  </cookie-law>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import ActionButton from './ActionButton.vue';

export default {
  components:{
    ActionButton,
    CookieLaw,
  }
};
</script>